module.exports = __webpack_public_path__ + "img/r4.9f6b0d24.jpg";